'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nb_NO = require('../../date-picker/locale/nb_NO');

var _nb_NO2 = _interopRequireDefault(_nb_NO);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _nb_NO2['default'];